import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles/alnakhba-variables.css';
import './index.css';
import './styles/rtl-overrides.css';
import App from './App';
import {BrowserRouter} from 'react-router-dom';
import { AuthProvider } from './context/auth';
import { CartProvider } from './context/cart';
import 'antd/dist/reset.css';
import { SearchProvider } from './context/search';
import { ConfigProvider } from 'antd';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <AuthProvider>
    <SearchProvider>
      <CartProvider>
        <ConfigProvider direction="rtl">
          <BrowserRouter>
            <App />
          </BrowserRouter>
        </ConfigProvider>
      </CartProvider>
    </SearchProvider>
  </AuthProvider>
);
